var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["accordion__item", _vm.isOpened ? "is-opened" : null],
      attrs: { id: "section-" + _vm.index }
    },
    [
      _c(
        "div",
        {
          staticClass: "accordion__item-title",
          on: {
            click: function() {
              return _vm.toggle(null, true)
            }
          }
        },
        [
          _c("v-typo", {
            attrs: { "data-hovered": "true", variant: "h4" },
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "roll" },
          on: {
            enter: _vm.rollEnter,
            leave: _vm.rollLeave,
            "after-enter": _vm.rollAfterEnter
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpened,
                  expression: "isOpened"
                }
              ],
              staticClass: "accordion__item-content"
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "column" },
                  _vm._l(_vm.content, function(paragraph, paragraphIndex) {
                    return _c("v-typo", {
                      key: "accordion-item-content-" + paragraphIndex,
                      ref: "content",
                      refInFor: true,
                      attrs: {
                        classes: ["accordion__item-content"],
                        variant: "body-paragraph"
                      },
                      domProps: { innerHTML: _vm._s(paragraph) }
                    })
                  }),
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }